import { render, staticRenderFns } from "./InfoArea.vue?vue&type=template&id=2c0fa82e&"
import script from "./InfoArea.vue?vue&type=script&lang=ts&"
export * from "./InfoArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports